import { gql } from '@apollo/client';

export const QUALIFY_PATIENT_IDENTITY = gql`
  mutation QualifyPatientIdentity($record: GqlQualifyPatientIdentityInput!) {
    insi {
      qualifyPatientIdentity(record: $record) {
        ok
        error {
          code
          message
          description
          params
        }
        result {
          patientId
          status
        }
      }
    }
  }
`;
